import { SectionParagraph as Subtitle } from '@/components/shared/Content';
import { Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';
import type { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { ImpactSectionContainer, Section, GBSectionTitle } from './StyledElements';
import { ImpactIconItem } from './ImpactIconItem';
import parse from 'html-react-parser';

const StyledSubtitle = styled(Subtitle)`
  text-align: left;
  padding: 0;
  text-wrap: initial;

  ${MEDIA_QUERIES.tabletAndDesktop`
      text-align: center;
  `}
`;

export const ImpactItemDescriptionText = styled.p`
  ${font('main', {
    fontSize: '1.6rem',
    lineHeight: '2.3rem',
  })}
  ${MEDIA_QUERIES.tabletAndDesktop`
    text-align: center;
    lineHeight: '145%',
  `}
`;

export interface ImpactItemProps {
  title: string;
  desc: string;
  impact: string;
  image: StaticImageData;
  imageMobile: StaticImageData;
}

export interface ImpactSectionProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle: string;
  impactItems: ImpactItemProps[];
}

export const OurCommunityImpact: FC<ImpactSectionProps> = ({ title, subtitle, impactItems }) => {
  return (
    <Section mb={0} py={[50, 50, 96]} contain="paint">
      <Flex gap="8px" flexDirection="column" px={[20, 0]}>
        <GBSectionTitle>{title}</GBSectionTitle>
        <StyledSubtitle>{parse(subtitle)}</StyledSubtitle>
      </Flex>

      <ImpactSectionContainer
        mt={[40, 40, 50]}
        pl={[20, 0]}
        pr={[22, 0]}
        justifyContent={['flex-start', 'center']}
        flexWrap={['nowrap', 'wrap']}
        width={1}
        maxWidth={['100%', '1200px']}
        flexDirection={['column', 'row']}
      >
        {impactItems.map(item => (
          <ImpactIconItem key={item.title} {...item} />
        ))}
      </ImpactSectionContainer>
    </Section>
  );
};
